export default function Dashboard() {
  return (
    <div className="container-fluid p-0">

					<h1 className="h3 mb-3"> Dashboard</h1>

					<div className="row">
						<div className="col-12">
							<div className="card">
								<div className="card-body">
									<h5 className="card-title mb-0">Welcome to Parlour Suite</h5>
								</div>
							</div>
						</div>
					</div>

				</div>
  );
}
